{
  "CONFIRMATION__PAGE__TITLE": "Confirmation",
  "DOCUMENTS__ACCESS_EXPIRES_IN_X_DAYS": "L'accès expire dans {{days}} jour(s)",
  "DOCUMENTS__DOWNLOAD_ALL": "Télécharger tout",
  "DOCUMENTS__EXPIRED__DESCRIPTION": "Les documents que vous essayez de consulter ne sont plus disponibles. Veuillez demander à votre interlocuteur de vous renvoyer les documents.",
  "DOCUMENTS__EXPIRED__TITLE": "Document(s) plus disponible(s)",
  "DOCUMENTS__OVERVIEW__PAGE__TITLE": "Aperçu",
  "DOCUMENTS__PAGE__TITLE": "Documents",
  "DOCUMENTS__TITLE": "Documents",
  "DOWNLOAD": "Télécharger",
  "FORMS__ERROR__MIN_LENGTH": "Entrez un minimum de {{minlength}} caractères",
  "FORMS__ERROR__REQUIRED": "Obligatoire",
  "LOGIN__CODE": "Code",
  "LOGIN__DESCRIPTION": "Nous avons envoyé un code de sécurité au numéro de téléphone indiqué. Veuillez saisir le code pour terminer la vérification.",
  "LOGIN__PAGE__TITLE": "Se connecter",
  "LOGIN__RESEND_CODE": "Renvoyer le code",
  "LOGIN__RESEND_COOLDOWN": "Veuillez patienter encore {{seconds}} secondes avant de réessayer",
  "LOGIN__SUBMIT": "Voir les documents",
  "LOGIN__TITLE": "Entrez le code de connexion",
  "LOGIN_FAILED__TOO_MANY_REQUESTS": "Veuillez attendre un instant avant de réessayer.",
  "LOGIN_FAILED__TOO_MANY_REQUESTS__TITLE": "Trop de tentatives de vérification",
  "LOGIN_FAILED__UNAUTHORIZED": "Accès refusé. Veuillez vérifier que votre code a été introduit correctement.",
  "LOGOUT": "Déconnexion",
  "NO_PREVIEW": "Pas d'aperçu",
  "PAGE_NOT_FOUND": "Page introuvable",
  "UNKNOWN_ERROR__TEXT": "Si le problème persiste, veuillez contacter l'expéditeur du document.",
  "UNKNOWN_ERROR__TITLE": "Erreur inconnue",
  "VERIFICATION__BUTTON": "Démarrer la vérification",
  "VERIFICATION__DESCRIPTION": "Pour consulter les documents, veuillez vérifier votre identité en utilisant le numéro de téléphone ci-dessous. Vous recevrez un code unique par SMS ou par appel téléphonique. Saisissez ce code pour terminer la vérification.",
  "VERIFICATION__ERROR__DESCRIPTION": "Si le problème persiste, veuillez contacter l'expéditeur du document.",
  "VERIFICATION__ERROR__TITLE": "Quelque chose n'a pas fonctionné",
  "VERIFICATION__PAGE__TITLE": "Vérification",
  "VERIFICATION__TITLE": "Un document a été partagé avec vous"
}
